// onboarding
import pricing from './onboarding/pricing'
import create_org from './onboarding/create_org'
import agreement from './onboarding/agreement'
import tooltips_text from './onboarding/tooltips_text'
import sign_up from './onboarding/sign_up'
import confirm_email from './onboarding/confirm_email'
import request_sales from './onboarding/request_sales'
import invites from './onboarding/invites'
import invites_page from './onboarding/invites_page'
import billing from './onboarding/billing'
import gruender_service from './onboarding/gruender_service'
// profile
import profile from './profile/profile'
import my_profile from './profile/my_profile'
import mybilling from './profile/billing'
import team from './profile/team'
import students from './profile/students'
// signin
import signin from './signin/signin'
import reset_pass from './signin/reset_pass'
import create_pass from './signin/create_pass'
import select_organization from './signin/select_organization'
// address
import address from './address'
// validation
import validations from './validations'
// errors
import toasts from './toasts'
// statuses
import statuses from './statuses'
// roles
import role from './role'

// Lehrbertribe company
import lehrbetribe from './lehrbetribe'
// wkis
import wkis from './wkis'

export default {
  pricing,
  create_org,
  agreement,
  sign_up,
  confirm_email,
  tooltips_text,
  invites,
  invites_page,
  billing,
  request_sales,
  gruender_service,

  mybilling,
  profile,
  my_profile,
  team,
  students,

  signin,
  reset_pass,
  create_pass,
  select_organization,

  validations,
  toasts,

  statuses,

  role,

  lehrbetribe,
  wkis,
  address,

  buttons: {
    submit: 'Bestätigen',
    send: 'Absenden',
    cancel: 'Abbrechen',
    upgrade: 'Upgrade',
    probemonat: 'Probemonat beenden',
    ok: 'Okay',
    retry: 'Retry',
    close: 'Schließen',
    toggle_navigation: 'Toggle navigation',
    next: 'Next',
    prev: 'Prev',
    more: 'Mehr Aktionen',
  },

  day: 'tag | tagen',

  loading: 'Loading...',
  skip_link: 'Zum Hauptinhalt springen',
  toggle: 'umschalten',
  actions: 'Aktionen',
  not_found: '0',
  close: 'Close',
}
